export default __webpack_public_path__ + "static/media/Banner.5b17d124.png";